import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { PLATFORMS, IMG_CDN_URL } from '@constants';
import { partners } from './constants';

import styles from './styles/index.module.scss';

const Partner = memo(({ platform }) => {
  if (platform !== PLATFORMS.ITALY) return null;

  return (
    <div className={styles.container}>
      {partners.map(({ alt, src, dataQa }) => (
        <img
          key={alt}
          alt={alt}
          src={`${IMG_CDN_URL}/${src}`}
          className={styles.partner}
          data-qa={dataQa}
        />
      ))}
    </div>
  );
});

Partner.propTypes = {
  platform: PropTypes.string.isRequired,
};

Partner.displayName = 'Partner';

export default Partner;
